// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Notifications from '../components/NotificationsMenu';
import {actions as NotificationsActions} from '../../../duck';

import type {RootState} from '../../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    notifications: state.notifications.unseenNotifications,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...NotificationsActions,
      },
      dispatch
    )
)(Notifications);
